import AdjustOutlined from "@mui/icons-material/AdjustOutlined";
import CheckCircleOutlineRounded from "@mui/icons-material/CheckCircleOutlineRounded";
import ErrorOutlineRounded from "@mui/icons-material/ErrorOutlineRounded";
import PendingOutlined from "@mui/icons-material/PendingOutlined";
import { Skeleton } from "@mui/material";
import { SubmissionStepState } from "hooks/useSubmissionSteps";

export const SubmissionStepStatusIcon = ({ status }: { status?: SubmissionStepState }) => {
  switch (status) {
    case SubmissionStepState.NotStarted:
      return <AdjustOutlined color="action" />;
    case SubmissionStepState.InProgress:
      // Not RadioButtonChecked — a filled ring next to nav items reads as the
      // selected step rather than as a status.
      return <PendingOutlined color="primary" />;
    case SubmissionStepState.Done:
      return <CheckCircleOutlineRounded color="success" />;
    case SubmissionStepState.Invalid:
      return <ErrorOutlineRounded color="error" />;
    case undefined:
      return <Skeleton variant="circular" width={20} height={20} />;
    default:
      ((_: never) => {
        throw new Error(`Unexpected value: ${_}`);
      })(status);
  }
};
